export const initializeGoogleConsent = () => {
    window.dataLayer = window.dataLayer || []

    const gtag = (...args: unknown[]) => {
        window.dataLayer.push(args)
    }

    gtag('consent', 'default', {
        ad_storage: 'denied',
        analytics_storage: 'denied',
        functionality_storage: 'denied',
        personalization_storage: 'denied',
        security_storage: 'granted',
        wait_for_update: 500,
    })
    gtag('set', 'ads_data_redaction', true)
}
